export const contact = {
  email: 'inquiries@esworld.com',
  emailLink: 'mailto:inquiries@esworld.com',
  whatsappDisplay: '+971 52 701 4480',
  whatsappLink: 'https://wa.me/971527014480',
  phoneDisplay: '+971 52 701 4480',
  phoneLink: 'tel:+971527014480',
  // Placeholder: points to the photo gallery until a 360° tour is available.
  virtualTourPath: '/about/media',
};
